import { render } from "./CardThirtySix.vue?vue&type=template&id=653b243b"
import script from "./CardThirtySix.vue?vue&type=script&lang=js"
export * from "./CardThirtySix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__